var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgShield = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 47,
    viewBox: "0 0 37 47",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED3615"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ED3615",
    d: "M17.49 0c-.143 0-.283.021-.417.063L.998 5.075c-.571.177-.966.7-.984 1.298-.007.243-.002.313-.003.715L.009 8.723c-.002 1.339-.004 3.1-.004 4.865l-.003 7.17-.002.001v.007C.012 31.622 6.841 41.303 17.036 44.92c.3.107.631.107.932 0 10.191-3.62 17.017-13.3 17.03-24.154v-.05c.006.196-.002-.23-.002-.63-.002-.402-.002-.963-.004-1.632l-.009-4.866-.008-4.867-.006-1.636c-.001-.202-.001-.363-.003-.481s.009-.048-.005-.274c-.037-.584-.427-1.083-.984-1.255L17.904.064C17.769.02 17.629 0 17.489 0h0zm-.003 2.878l14.68 4.576c.002.365.004.752.004 1.274.004 1.337.007 3.1.009 4.863.003 1.764.005 3.529.009 4.866.001.67.001 1.231.003 1.634.002.381-.003.46.004.682-.016 9.5-5.875 17.972-14.695 21.32-8.825-3.347-14.688-11.823-14.7-21.331v.007c.003-.234.003-3.652.004-7.18l.004-4.865.002-1.272 14.676-4.574z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.34 15.001c-.417.014-.81.186-1.1.48-3.913 3.87-6.878 7.081-10.56 10.778l-4.045-3.375c-.323-.271-.742-.405-1.164-.371-.423.034-.815.23-1.09.55-.274.318-.41.73-.376 1.148.033.417.234.804.557 1.075l5.194 4.335c.635.537 1.582.499 2.172-.086 4.294-4.246 7.356-7.644 11.585-11.824.475-.454.62-1.152.358-1.754-.26-.602-.87-.982-1.532-.956z",
    transform: "translate(1 1)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShield, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield.df4d9dcc.svg";
export { ForwardRef as ReactComponent };